import { CookieManagementEnum } from './cookieManagementEnum';

export interface OptionalCookie {
    name: string;
    enumValue: CookieManagementEnum;
    isSelected: boolean;
}

export function createOptionalCookie(name: string, enumValue: CookieManagementEnum): OptionalCookie {
    return {
        name: name.toLowerCase(),
        enumValue,
        isSelected: false
    };
}
